import { Notification, NotificationApi, NotificationTypeEnum } from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import NotifikaciaHistoria from '../../../model/notifikacia/NotifikaciaHistoria';
import { mapNotifikacia } from './notifikaciaHistoriaListClient';
import { NotifikaciaTypEnum } from '../../../model/notifikacia/NotifikaciaTyp';
import Uuid from '../../../model/Uuid';

const client = new NotificationApi(apiConfiguration(evidenciaPrefixPath));

const mapToNotification = (notificationType: NotifikaciaTypEnum): Notification => ({
  notificationType: NotificationTypeEnum[Object.keys(NotificationTypeEnum)[Object.values(NotificationTypeEnum)
    .indexOf(notificationType as unknown as NotificationTypeEnum)]],

});

// eslint-disable-next-line import/prefer-default-export
export const sendNotification = async (
  materialUuid: Uuid,
  notificationType: NotifikaciaTypEnum,
  headers?: object,
):
  Promise<ClientResponse<NotifikaciaHistoria>> => {
  const {
    status,
    data,
  } = await client.sendNotificationAsAdmin(
    materialUuid,
    mapToNotification(notificationType),
    headers,
  );
  return {
    data: data ? mapNotifikacia(data) : null,
    responseCode: status,
  };
};
